import React, { useRef } from 'react';
import classNames from 'classnames';
import '../../css/clydeTextArea.css';
var ClydeTextArea = function (props) {
    var className = props.className, cols = props.cols, disabled = props.disabled, focusDarken = props.focusDarken, hidden = props.hidden, id = props.id, maxLength = props.maxLength, minLength = props.minLength, name = props.name, onChange = props.onChange, onSubmit = props.onSubmit, placeholder = props.placeholder, readonly = props.readonly, rows = props.rows, spellCheck = props.spellCheck, value = props.value, dataTestValue = props.dataTestValue;
    var textAreaRef = useRef(null);
    var _changeHandler = function (e) {
        if (!disabled && !hidden && !readonly) {
            onChange(e);
        }
    };
    var _submitHandler = function (e) {
        if (!disabled && !hidden && !readonly && e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
            if (typeof onSubmit === 'function') {
                // If onSubmit exists then it is called instead of submitting form on cmd || ctrl + enter
                onSubmit(e);
                return;
            }
            if (textAreaRef && textAreaRef.current && textAreaRef.current.form) {
                // If no onSubmit and textarea is inside form, submit form instead
                e.preventDefault();
                textAreaRef.current.form.submit();
            }
        }
    };
    var _className = classNames('clyde-text-area', className, {
        'clyde-text-area--hidden': hidden,
        'clyde-text-area--disabled': disabled,
        'clyde-text-area--focus-darken': focusDarken,
    });
    return (React.createElement("textarea", { className: _className, cols: cols, disabled: disabled, id: id || '', maxLength: maxLength, minLength: minLength, name: name, onChange: _changeHandler, onKeyDown: _submitHandler, placeholder: placeholder, readOnly: readonly, ref: textAreaRef, rows: rows, spellCheck: spellCheck, value: value, "data-test": dataTestValue }));
};
export default ClydeTextArea;
